import React from 'react';
import {getData} from "../service/fetcher";

export default class PhotoMapChoser extends React.Component {

    constructor(props) {
        super(props);
        this.input = this.input.bind(this);
        getData("/api/ListPhotoMaps", {token:this.props.token})[0].then((data) => this.setState({folders: data}), console.log("failed to load folders"));
    }

    input(e) {
        this.setState({filter: e.target.value})
    }

    state = {folders: [], filter: ""};

    render() {
        return (
            <div>
                <input type="text" onChange={(e) => this.input(e)} placeholder={"Zoek een map"}/>
                <div className={"folders"}>
                    {this.state.folders.length === 0 && <p>Loading</p>}
                    {this.state.folders.length > 0 && this.state.folders.filter(el => el.folder.toLowerCase().includes(this.state.filter)).slice(0,20).map((e) =>
                        <a onClick={() => this.props.page("folder", e.id)} id={e.id}>{e.folder}</a>
                    )}
                    {this.props.admin && this.state.folders.filter(el => el.folder.toLowerCase().includes(this.state.filter)).length === 0 &&
                    <button onClick={() => this.props.page("create", this.state.filter)}>Nieuwe map
                        aanmaken?</button>}
                </div>
            </div>
        );
    }


}
